export const SERVICE_ERROR = 'SERVICE_ERROR';
export const SERVICE_REQUEST = 'SERVICE_REQUEST';
export const SERVICE_SUCCESS = 'SERVICE_SUCCESS';
export const SERVICE_UPDATE = 'SERVICE_UPDATE';
export const SERVICE_STATUS_UPDATE = 'SERVICE_STATUS_UPDATE';
